import {V1ETLJobSystemExecutionLogIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import EnlilAxios from "../../../../util/EnlilAxios";

class ETLJobSystemExecutionLogEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        EnlilAxios({
            method: "GET",
            url: "t1/v1/etl_job_system_execution_logs",
            json: true,
            params: {
                "ETLJobExecutionUSID": foreignKey
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.ETLJobSystemExecutionLog-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ETLJobSystemExecutionLogIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

}

export default ETLJobSystemExecutionLogEnterpriseComponent;